import { useContext } from "react";
import './Locations.css';
import { LocaleContext } from "../common/App";
import { useIndexUpdate, } from "../common/hooks";
import { LinkSmart } from "../common/Common";
import { locationSettings, locationStartPagesSettings } from "../common/globals_common.mjs";
import { system } from "../common/globals.mjs";
import { LocationStartPage } from "../common/enums.mjs";
import { isLocationStartPageActive } from "../common/util_module.mjs";
import { Footer } from "./WebsiteCommon";

export function Locations(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);


    // RENDER:

    return (
        <div className="locations">
            <div className="margin_to_header side_padding bottom_padding">
                <h1 className="text_big_big">{locale.msgs.LOCATION_PAGES}</h1>

                <div className="text">{locale.msgs.LOCATION_PAGES_DESCR}</div>

                <div className="locations_links">
                    { isLocationStartPageActive(LocationStartPage.MUNICH) ?
                        <div>
                            <LinkSmart className="text_2 link_2" to={locationStartPagesSettings[LocationStartPage.MUNICH].path}>{locale.msgs.START_NAME_ON_LOCATIONS_PAGE_MUNICH}</LinkSmart>
                        </div>
                    :
                        null
                    }

                    { isLocationStartPageActive(LocationStartPage.NUREMBERG) ?
                        <div>
                            <LinkSmart className="text_2 link_2" to={locationStartPagesSettings[LocationStartPage.NUREMBERG].path}>{locale.msgs.START_NAME_ON_LOCATIONS_PAGE_NUREMBERG}</LinkSmart>
                        </div>
                    :
                        null
                    }

                    { isLocationStartPageActive(LocationStartPage.HAMBURG) ?
                        <div>
                            <LinkSmart className="text_2 link_2" to={locationStartPagesSettings[LocationStartPage.HAMBURG].path}>{locale.msgs.START_NAME_ON_LOCATIONS_PAGE_HAMBURG}</LinkSmart>
                        </div>
                    :
                        null
                    }

                    { isLocationStartPageActive(LocationStartPage.BERLIN) ?
                        <div>
                            <LinkSmart className="text_2 link_2" to={locationStartPagesSettings[LocationStartPage.BERLIN].path}>{locale.msgs.START_NAME_ON_LOCATIONS_PAGE_BERLIN}</LinkSmart>
                        </div>
                    :
                        null
                    }

                    { isLocationStartPageActive(LocationStartPage.FRANKFURT) ?
                        <div>
                            <LinkSmart className="text_2 link_2" to={locationStartPagesSettings[LocationStartPage.FRANKFURT].path}>{locale.msgs.START_NAME_ON_LOCATIONS_PAGE_FRANKFURT}</LinkSmart>
                        </div>
                    :
                        null
                    }

                    { isLocationStartPageActive(LocationStartPage.COLOGNE) ?
                        <div>
                            <LinkSmart className="text_2 link_2" to={locationStartPagesSettings[LocationStartPage.COLOGNE].path}>{locale.msgs.START_NAME_ON_LOCATIONS_PAGE_COLOGNE}</LinkSmart>
                        </div>
                    :
                        null
                    }

                </div>
            </div>

            <Footer />
        </div>
    );
}
